<input nbInput
       id="date"
       [disabled]="isDisabled"
       [ngModel]="timeToString(value)"
       (ngModelChange)="value = stringToTime($event)"
       fullWidth
       placeholder="Datum"
       type="time">
